<template>
  <div class="asc-plot-footer">
    <template v-if="miniPlot">
      <asc-hover-link
        :icon="getHoverLinkIcon"
        :text="getHoverLinkText"
        @on-click="handleClick"
      ></asc-hover-link>
    </template>
    <div class="asc-plot-footer--caption">
      <asc-caption
        :caption="caption"
        :disabled="isCaptionDisabled"
        :max-length="300"
        :has-counter="true"
        :always-display-label="!miniPlot"
        @blur="handleUpdateCaption"
      ></asc-caption>
    </div>
  </div>
</template>

<script>
import AscHoverLink from './AscHoverLink'
import AscCaption from './AscCaption'

export default {
  name: 'AscPlotFooter',

  components: {
    AscHoverLink,
    AscCaption,
  },

  props: {
    pagePlot: {
      type: Object,
      default: () => {},
    },
    miniPlot: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    onUpdateCaption: {
      type: Function,
      default: () => {},
    },
    onExpand: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      caption: this.pagePlot?.caption || '',
    }
  },

  computed: {
    getHoverLinkIcon() {
      return this.editable ? 'pencil' : 'arrowExpand'
    },

    getHoverLinkText() {
      return this.editable
        ? 'View and Edit in Fullscreen'
        : 'View in Fullscreen'
    },

    isCaptionDisabled() {
      return this.miniPlot || !this.editable
    },
  },

  watch: {
    pagePlot: {
      deep: true,
      handler(newPagePlot) {
        this.pagePlot = newPagePlot
        this.caption = newPagePlot.caption || ''
      },
    },
  },

  methods: {
    handleClick() {
      if (this.onExpand) {
        this.onExpand(this.pagePlot.id)
      }
    },

    handleUpdateCaption(value) {
      if (this.onUpdateCaption) {
        this.onUpdateCaption(this.pagePlot.id, this.pagePlot.plotTypeId, value)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-plot-footer {
  min-height: 45px;

  &--caption {
    border-top: 1px solid $gray-500;

    .asc-caption {
      textarea {
        min-height: 38px;
        overflow-y: auto;
        margin-bottom: 12px;
      }

      .v-text-field {
        margin: 0 8px 12px 0;
      }
    }
  }
}
</style>
